module.exports = {"321371050":"黄河街道办","321371052":"三棵树街道办","321371351":"南蔡乡","321371400":"古楚街道办"}


//////////////////
// WEBPACK FOOTER
// ./src/town/321371.json
// module id = 940
// module chunks = 0